export default "__VITE_ASSET__DsMCliKx__"